import { GetRestrictedCathrinUsersResponse } from "@/app/api/restricted-cathrin-users/route";
import { getRestrictedCathrinUsersRequestSchema } from "@/lib/schemas/restricted-cathrin-users";
import { createInvalidateQuery, createQueryHook } from "@/lib/queries";

const RESTRICTED_CATHRIN_USERS_ENDPOINT = "/api/restricted-cathrin-users";

export const invalidateRestrictedCathrinUsersQuery = createInvalidateQuery(
  RESTRICTED_CATHRIN_USERS_ENDPOINT,
);

export const useRestrictedCathrinUsersQuery =
  createQueryHook<GetRestrictedCathrinUsersResponse>(
    RESTRICTED_CATHRIN_USERS_ENDPOINT,
    getRestrictedCathrinUsersRequestSchema,
  );
